import type { Assessment, CriterionScore, QuestionTypeScore, Skill } from './types'

export const skillMeta: Record<Skill, { label: string; short: string; color: string }> = {
  speaking: { label: 'Speaking', short: 'SP', color: '#d8683e' },
  writing: { label: 'Writing', short: 'WR', color: '#256d85' },
  reading: { label: 'Reading', short: 'RE', color: '#8d6b32' },
  listening: { label: 'Listening', short: 'LI', color: '#67558c' },
}

export const speakingCriteria = [
  ['fc', 'Fluency & Coherence'],
  ['lr', 'Lexical Resource'],
  ['gra', 'Grammatical Range & Accuracy'],
  ['pr', 'Pronunciation'],
] as const

export const writingCriteria = [
  ['tr', 'Task Achievement / Response'],
  ['cc', 'Coherence & Cohesion'],
  ['lr', 'Lexical Resource'],
  ['gra', 'Grammatical Range & Accuracy'],
] as const

export const readingQuestionTypes = [
  'Multiple Choice', 'True / False / Not Given', 'Yes / No / Not Given',
  'Matching Headings', 'Matching Information', 'Matching Features',
  'Matching Sentence Endings', 'Sentence Completion', 'Summary / Note / Table Completion',
  'Diagram Label Completion', 'Short-answer Questions',
]

export const listeningQuestionTypes = [
  'Multiple Choice', 'Matching', 'Plan / Map / Diagram Labelling',
  'Form / Note / Table Completion', 'Sentence Completion', 'Short-answer Questions',
]

export function roundIelts(value: number): number {
  return Math.round(value * 2) / 2
}

export function criterionOverall(criteria: CriterionScore[]): number {
  if (!criteria.length) return 0
  return roundIelts(criteria.reduce((sum, item) => sum + item.score, 0) / criteria.length)
}

export function questionAccuracy(items: QuestionTypeScore[]): number {
  const total = items.reduce((sum, item) => sum + item.total, 0)
  if (!total) return 0
  return Math.round((items.reduce((sum, item) => sum + item.correct, 0) / total) * 100)
}

export function assessmentDisplayScore(assessment: Assessment): string {
  if (assessment.skill === 'reading' || assessment.skill === 'listening') {
    return `${assessment.overall ?? 0}%`
  }
  return (assessment.overall ?? 0).toFixed(1)
}

export function latestBySkill(assessments: Assessment[], skill: Skill): Assessment | undefined {
  return assessments
    .filter((item) => item.skill === skill && item.status === 'completed')
    .sort((a, b) => b.date.localeCompare(a.date))[0]
}
